import { useOpenCircleAi } from "./useOpenCircleAi";

export const useOpenRecentChat = () => {
  const { openConversation } = useOpenCircleAi();

  return (uuid: string, title?: string | null, projectId?: string | null) =>
    openConversation(uuid, { projectId, title });
};
